export default "__VITE_ASSET__DBTFi6St__"